<template>
  <v-menu bottom rounded offset-y>
    <template v-slot:activator="{ on }">
      <v-btn dark text large v-on="on">
        <v-icon dark left>mdi-menu-down</v-icon>
        <v-icon color="blue" dark left>mdi-google-classroom</v-icon>
        <strong>{{ selectedProperty.propertyName }}</strong>
      </v-btn>
    </template>
    <v-card max-height="300" class="overflow-y-auto">
      <v-list>
        <v-list-item v-for="item in properties" :key="item.targetName" @click="onClickListItem(item)">
          <v-icon color="blue" left>mdi-google-classroom</v-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.propertyName }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import Store from '@/store';
import { updateSelectedProperty } from '@/libs/store';
import { setProgress } from '@/libs/store/progress';

@Component
export default class ProppertySelectMenu extends Vue {
  get properties() {
    return Store.getters.properties;
  }

  get selectedProperty() {
    return Store.getters.selectedProperty;
  }

  private async onClickListItem(property: any) {
    const { targetName } = property;
    setProgress(true);
    await updateSelectedProperty(targetName);
    setProgress(false);
  }
}
</script>
